import React from "react";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

const FcmTokenCleanupConfigPanel = ({ fcmTokenCleanup, updateFcmTokenCleanup }) => (
  <section className="system-config-panel">
    <div className="system-config-section">
      <div className="system-config-panel-head">
        <div>
          <h3>FCM token cleanup</h3>
          <p>Remove expired auth-token links and rebuild each user's active browser notification tokens.</p>
        </div>
      </div>

      <div className="system-config-schedule-grid">
      <label className={`system-config-switch-card ${fcmTokenCleanup.enabled ? "enabled" : ""}`}>
        <span>
          <strong>Enable cleanup job</strong>
          <small>Runs in the cron worker and only removes expired token records.</small>
        </span>
        <input
          type="checkbox"
          checked={fcmTokenCleanup.enabled}
          onChange={(event) => updateFcmTokenCleanup({ enabled: event.target.checked })}
        />
      </label>

        <label className="system-config-schedule-card">
          <span className="system-config-schedule-icon"><AccessTimeOutlinedIcon /></span>
          <span className="system-config-schedule-copy">
            <strong>Run every</strong>
            <small>Default is 3 hours.</small>
          </span>
          <span className="system-config-schedule-control">
            <input
              type="number"
              min="1"
              step="1"
              value={fcmTokenCleanup.intervalHours}
              onChange={(event) => updateFcmTokenCleanup({ intervalHours: event.target.value })}
              aria-label="FCM cleanup interval in hours"
            />
            <em>hours</em>
          </span>
        </label>
      </div>
    </div>
  </section>
);

export default FcmTokenCleanupConfigPanel;
